//imports
import {
	AUTH_REFRESH_TOKEN,
	AUTH_REFRESH_TOKEN_RESULT,
	AUTH_CHANGE_PASSWORD_OPEN_MODAL,
	AUTH_CHANGE_PASSWORD_REQUEST,
	AUTH_CHANGE_PASSWORD_RESULT,
	AUTH_GET_PREFERENCES_RESULT,
	AUTH_GET_AUTHENTICATION_DETAILS_REQUEST,
	AUTH_GET_AUTHENTICATION_DETAILS_RESULT,
	CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
	loading: false,
	user: null,
	error: null,
	refreshTokenResult: false,
	authenticatedId: null,
	openModalChangePassword: false,
	loadingChangePassword: false,
	resultChangePassword: null,
	errorChangePassword: null,
	systemPreference: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case AUTH_REFRESH_TOKEN:
			return { ...state, refreshTokenResult: false };

		case AUTH_REFRESH_TOKEN_RESULT:
			return { ...state, refreshTokenResult: action.payload };

		case AUTH_CHANGE_PASSWORD_OPEN_MODAL:
			return { ...state, openModalChangePassword: action.payload };

		case AUTH_CHANGE_PASSWORD_REQUEST:
			return { ...state, loadingChangePassword: true };

		case AUTH_CHANGE_PASSWORD_RESULT:
			return { ...state, loadingChangePassword: false, resultChangePassword: action.payload.result, errorChangePassword: action.payload.error };

		case AUTH_GET_PREFERENCES_RESULT:
			return { ...state, systemPreference: action.payload }
		case AUTH_GET_AUTHENTICATION_DETAILS_REQUEST:
			return { ...state, loading: true }

		case AUTH_GET_AUTHENTICATION_DETAILS_RESULT:
			
			return { ...state, user: action?.payload, loading: false }

		case CLEAR_REDUX:
			return ["", "AUTH"].includes(action.payload.option)
				? action.payload.parameters
					? { ...state, ...action.payload.parameters }
					: { ...INIT_STATE }
				: { ...state };

		default:
			return state;
	}
};
